import TwoColumnLayout from './TwoColLayout'

export default TwoColumnLayout
